import React, {useState, useRef, useEffect} from "react";
import * as management from "../../actions/management";
import * as auth from "../../actions/auth";
import connect from "react-redux/lib/connect/connect";
import {Toast} from "primereact/toast";
import Spinner from "../../spinner/Spinner";
import {Steps} from "primereact/steps";
import {InputText} from "primereact/inputtext";
import {InputTextarea} from "primereact/inputtextarea";
import {Button} from "primereact/button";
import {SelectButton} from "primereact/selectbutton";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import "../../css/StepsDemo.css";
import {Tag} from "primereact/tag";
import {Chip} from "primereact/chip";
import {Message} from "primereact/message";


const AddServer = props => {
    // Definitions
    const toast = useRef(null);
    const [loadingState, setLoadingState] = useState(false);
    const [activeIndex, setActiveIndex] = useState(0);
    const [serverName, setServerName] = useState("");
    const [keypairName, setKeypairName] = useState("");
    const [keypairValidMessage, setKeypairValidMessage] = useState("");
    const [keypairValidType, setKeypairValidType] = useState("");
    const [serverDescription, setServerDescription] = useState("");
    const [applicableImages, setApplicableImages] = useState([]);
    const [reservations, setReservations] = useState([]);
    const [imageTableData, setImageTableData] = useState([]);
    const [reservationTableData, setReservationTableData] = useState([]);
    const [selectedSource, setSelectedSource] = useState(null);
    const [selectedReservation, setSelectedReservation] = useState(null);


    const items = [
        {
            label: 'Sunucu Bilgileri',
            command: (event) => {
                showInfo(event.item.label, 'Sunucu Bilgileri Giriniz');
            }
        },
        {
            label: 'Rezervasyon',
            command: (event) => {
                showInfo(event.item.label, 'Rezervasyon Seçiniz');
            }
        },
        {
            label: 'İmaj',
            command: (event) => {
                showInfo(event.item.label, 'İmaj Seçiniz');
            }
        },

        {
            label: 'Anahtar Çifti',
            command: (event) => {
                showInfo(event.item.label, 'Anahtar Çifti Seçiniz');
            }
        },
        {
            label: 'Özet',
            command: (event) => {
                showInfo(event.item.label, 'Bilgileri Kontrol Ediniz');
            }
        }
    ];

    useEffect(() => {
        getImages();
        getReservations();
    }, []);

    // Messages
    const showSuccess = (message) => {
        toast.current.show({severity: 'success', summary: message, life: 3000});
    }

    const showError = (message) => {
        toast.current.show({
            severity: 'error',
            summary: message,
            life: 3000
        });
    }

    const showInfo = (message, detail) => {
        toast.current.show({severity: 'info', summary: message, detail: detail, life: 3000});
    }

    // Requests
    const getImages = () => {
        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");
        if (token) {
            setLoadingState(true);
            headers["Authorization"] = `Token ${token}`;
            fetch("/api/cloud-applicable-image/", {headers, method: "GET"})
                .then(res => {
                    if (res.status < 500) {
                        setLoadingState(false);
                        return res.json().then(data => {
                            return {status: res.status, data};
                        })
                    } else {
                        //console.log("Server Error!");
                        throw res;
                    }
                })
                .then(res => {
                    if (res.status === 200) {
                        setLoadingState(false);
                        const data = res.data;
                        if (data.result) {
                            setApplicableImages(data.images);
                            const image_column_headers = ["ID", "İmaj Adı", "Güncellenme Tarihi", "Boyut"];
                            const image_column_fields = ["id", "name", "updated_time", "size"]
                            let image_data = Array();
                            for (let i = 0; i < image_column_fields.length; i++) {
                                image_data.push({
                                    "field": image_column_fields[i],
                                    "header": image_column_headers[i],
                                    "body": getComputeBody(image_column_fields[i], image_column_headers[i])
                                });
                            }
                            setImageTableData(image_data);
                        } else {
                            showError(data.message);
                        }
                    } else if (res.status === 401) {
                        props.loadUser();
                        setLoadingState(false);
                        throw res.data;

                    } else if (res.status === 403) {
                        setLoadingState(false);
                        throw res.data;

                    }
                })

        }
    }

    const getReservations = () => {
        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");
        if (token) {
            setLoadingState(true);
            headers["Authorization"] = `Token ${token}`;
            fetch("/api/usable-reservations/", {headers, method: "GET"})
                .then(res => {
                    if (res.status < 500) {
                        setLoadingState(false);
                        return res.json().then(data => {
                            return {status: res.status, data};
                        })
                    } else {
                        //console.log("Server Error!");
                        throw res;
                    }
                })
                .then(res => {
                    if (res.status === 200) {
                        setLoadingState(false);
                        const data = res.data;
                        if (data.result) {
                            setReservations(data.reservations);
                            const reservation_column_headers = ["ID", "Şablon Adı", "Başlama Tarihi", "Bitiş Tarihi"];
                            const reservation_column_fields = ["reservation_id", "flavor_name", "reservation_starttime", "reservation_finishtime"];
                            let reservation_data = Array();
                            for (let i = 0; i < reservation_column_fields.length; i++) {
                                reservation_data.push({
                                    "field": reservation_column_fields[i],
                                    "header": reservation_column_headers[i],
                                    "body": getComputeBody(reservation_column_fields[i], reservation_column_headers[i])
                                });
                            }
                            setReservationTableData(reservation_data);
                        } else {
                            showError(data.message);
                        }
                    } else if (res.status === 401) {
                        props.loadUser();
                        setLoadingState(false);
                        throw res.data;

                    } else if (res.status === 403) {
                        setLoadingState(false);
                        throw res.data;

                    }
                })

        }
    }

    const closeServerDialog = () => {
        props.setServerDialog(false);
        props.getServList();
    }

    const createServer = () => {
        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");
        if (token) {
            if (!serverName || serverName.length < 5) {
                showError("Sunucu Adı En Az 5 Karakterli Olmalıdır!");
                return;
            }
            if (!selectedReservation) {
                showError("Lütfen Bir Rezervasyon Seçiniz!");
                return;
            }
            if (!selectedSource) {
                showError("Lütfen Bir Kaynak Seçiniz!");
                return;
            }
            if (!keypairName || keypairName.length < 3) {
                showError("Anahtar Çifti Adı En Az 3 Karakterli Olmalıdır!");
                return;
            }

            const data = {
                "source": selectedSource.id,
                "server_name": serverName,
                "server_description": serverDescription,
                "reservation": selectedReservation.reservation_id,
                "keypair_name": keypairName,
            }
            const body = JSON.stringify(data);
            headers["Authorization"] = `Token ${token}`;
            showInfo();
            closeServerDialog();
            props.showInfoMessage("Sunucu Oluşturuluyor", "Sunucu");
            fetch("/api/cloud-server/", {headers, method: "POST", body: body})
                .then(res => {
                    if (res.status < 500) {
                        setLoadingState(false);
                        return res.json().then(data => {
                            return {status: res.status, data};
                        })
                    } else {
                        //console.log("Server Error!");
                        throw res;
                    }
                })
                .then(res => {
                    if (res.status === 200) {
                        const data = res.data;
                        if (data.result) {
                            props.showSuccessMessage(data.message);
                        } else {
                            props.showErrorMessage(data.message);
                        }
                    } else if (res.status === 401) {
                        props.loadUser();
                        setLoadingState(false);
                        throw res.data;

                    } else if (res.status === 403) {
                        setLoadingState(false);
                        throw res.data;

                    }
                })

        }
    }

    const isSuitableKeypair = (keypair_name) => {
        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");
        if (token) {
            if (keypair_name === null || keypair_name.length <= 2) {
                setKeypairValidMessage("Anahtar Çifti en az 3 karakter olmalıdır");
                setKeypairValidType("p-error");
                return;
            }
            headers["Authorization"] = `Token ${token}`;
            fetch("/api/cloud-keypair/" + keypair_name, {headers, method: "GET"})
                .then(res => {
                    if (res.status < 500) {
                        setLoadingState(false);
                        return res.json().then(data => {
                            return {status: res.status, data};
                        })
                    } else {
                        //console.log("Server Error!");
                        throw res;
                    }
                })
                .then(res => {
                    if (res.status === 200) {
                        const data = res.data;
                        if (data.result) {
                            setKeypairValidMessage(data.message);
                            setKeypairValidType("p-success");
                        } else {
                            setKeypairValidMessage(data.message);
                            setKeypairValidType("p-error");
                        }
                    } else if (res.status === 401) {
                        props.loadUser();
                        setLoadingState(false);
                        throw res.data;

                    } else if (res.status === 403) {
                        setLoadingState(false);
                        throw res.data;

                    }
                })

        }
    }

    // Controllers
    const textController = (func, value) => {
        var re = /^[a-zA-Z0-9 _ıİçÇşŞöÖüÜğĞ.]*$/;
        if (re.test(value) || value.length === 0) {
            func(value);
        } else {
            showError("Yalnızca Harf, Sayı ve Alt Çizgi Kullanılmalıdır");
        }
    }

    const keypairOnChange = (e, setKeypairName) => {
        const keypair_name = e.target.value
        textController(setKeypairName, keypair_name);
        isSuitableKeypair(keypair_name);
    }

    // Templates
    const getComputeBody = (compute_key, compute_name) => {
        const sizeBody = (rowData) => {
            return (
                <React.Fragment>
                    <div>
                        <div className="p-grid">
                            <div className="p-col-12">
                                <span className="p-column-title">{compute_name}</span>
                            </div>
                            <div className="p-col-12" style={{wordBreak: "break-all"}}>
                                {rowData[compute_key] ? rowData[compute_key] : <span>-</span>}
                            </div>
                        </div>
                    </div>
                </React.Fragment>
            );
        }
        return sizeBody;
    }

    const dataTableTemplate = (table_data, table_header, columns, type, is_selection) => {
        return (
            <div className="datatable-responsive-demo">
                <div className="card" style={{width: '100%'}}>
                    <DataTable value={table_data} className="p-datatable-responsive-demo"
                               header={<div align="center"><h4>{table_header}</h4></div>}
                               selection={type === "source" ? selectedSource : selectedReservation}
                               onSelectionChange={e => {
                                   type === "source" ? setSelectedSource(e.value) : setSelectedReservation(e.value)
                               }}
                               emptyMessage="Kayıt Bulunamadı."
                    >
                        {is_selection ? <Column selectionMode="single" headerStyle={{width: "3em"}}/> : null}
                        {columns.map((column, i) => {
                            if (column.field !== "id") {
                                if (i % 2 == 0) {
                                    return (
                                        <Column field={column.field}
                                                header={column.header}
                                                body={column.body}
                                                style={{textAlign: 'left', width: '5.5em'}}/>
                                    );
                                } else {
                                    return (
                                        <Column field={column.field}
                                                header={column.header}
                                                body={column.body}
                                                style={{fontWeight: 'bold', textAlign: 'left', width: '5.5em'}}/>
                                    );
                                }

                            }

                        })}
                    </DataTable>
                </div>
            </div>
        );
    }

    const afterStep = (message) => {
        return (
            <div className="p-col-12 p-sm-12 p-md-6 p-lg-6 p-xl-6" style={{marginBottom: "15px"}}>
                <div className="p-grid">
                    <div className="p-col-12 p-sm-12 p-md-7 p-lg-8 p-xl-8"></div>
                    <div className="p-col-12 p-sm-12 p-md-5 p-lg-4 p-xl-4" align="right">
                        <Button icon="pi pi-angle-double-right"
                                label="Sonraki Adım"
                                className="p-button-text p-button-raised p-button-secondary"
                                onClick={(e) => {
                                    setActiveIndex(activeIndex + 1);
                                    showInfo(items[activeIndex + 1].label, message);
                                }}/>
                    </div>
                </div>
            </div>

        );
    }

    const beforeStep = (message) => {
        return (
            <div className="p-col-12 p-sm-12 p-md-6 p-lg-6 p-xl-6" style={{marginBottom: "15px"}}>
                <div className="p-grid">
                    <div className="p-col-12 p-sm-12 p-md-5 p-lg-4 p-xl-4" align="left">
                        <Button icon="pi pi-angle-double-left"
                                label="Geri"
                                className="p-button-text p-button-raised p-button-secondary"
                                onClick={(e) => {
                                    setActiveIndex(activeIndex - 1);
                                    showInfo(items[activeIndex - 1].label, message);
                                }}/>
                    </div>
                    <div className="p-col-12 p-sm-12 p-md-7 p-lg-8 p-xl-8"></div>
                </div>
            </div>

        );
    }

    const finishStep = (message) => {
        return (
            <div className="p-col-12 p-sm-12 p-md-6 p-lg-6 p-xl-6" style={{marginBottom: "15px"}}>
                <div className="p-grid">
                    <div className="p-col-12 p-sm-12 p-md-7 p-lg-8 p-xl-8"></div>
                    <div className="p-col-12 p-sm-12 p-md-5 p-lg-4 p-xl-4" align="right">
                        <Button icon="pi pi-cloud-upload"
                                label="Sunucuyu Oluştur"
                                className="p-button-text p-button-raised p-button-secondary"
                                onClick={(e) => {
                                    showInfo("Sunucu Oluşturuluyor", message);
                                    createServer();
                                }}/>
                    </div>
                </div>
            </div>

        );
    }

    const summaryMessageTemplate = (label_name, val, icon_name) => {
        return (
            <div className="p-col-12 p-sm-12 p-md-6 p-lg-6 p-xl-6">
                <div className="p-grid">
                    <div className="p-col-6">
                        <strong>{label_name}</strong>
                    </div>
                    <div className="p-col-6" style={{wordBreak: "break-all"}}>
                        <Chip className="p-mr-2 p-mb-2" icon={"pi " + icon_name}
                              label={val ? val : <span>-</span>}/>
                    </div>
                </div>
            </div>
        );
    }

    // Sub-pages
    const imageSource = (
        <div className="p-grid" style={{width: "100%"}}>
            <div className="p-col-12">
                <Message severity="info"
                         className="p-mt-1"
                         text="Jupyter Makinası oluşturulacağı durumlarda tablodan jupyter yüklü imaj seçilmelidir."/>
                {dataTableTemplate(applicableImages, "UYGUN İMAJLAR", imageTableData, "source", true)}

            </div>
            {beforeStep("Rezervasyon Seçiniz")}
            {afterStep("Anahtar Çifti Ekleyiniz")}
        </div>
    );

    // Pages
    const serverInformations = (
        <div className="card" style={{marginTop: "10px"}}>
            <div className="p-grid">
                <div className="p-col-12">
                    <span className="p-float-label">
                        <InputText id="serverName" value={serverName}
                                   onChange={(e) => textController(setServerName, e.target.value)}/>
                        <label htmlFor="serverName">Sunucu Adı</label>
                    </span>
                    <Message severity="info"
                             className="p-mt-1"
                             text="Sunucu Adı sadece harf, sayı ve alt çizgi (_) içerebilir."/>
                </div>
                <div className="p-col-12" style={{marginTop: "10px"}}>
                    <span className="p-float-label">
                        <InputTextarea id="serverDescription" value={serverDescription}
                                       onChange={(e) => setServerDescription(e.target.value)}
                                       rows={5} cols={30}
                                       autoResize/>
                        <label htmlFor="serverDescription">Açıklama</label>
                    </span>
                </div>
                <div className="p-col-12 p-sm-12 p-md-6 p-lg-6 p-xl-6"></div>
                {afterStep("Rezervasyon Seçiniz")}
            </div>
        </div>
    );

    const selectSource = (
        <div className="card" style={{marginTop: "10px"}}>
            <div className="p-grid">
                <div className="p-col-12" align="center">
                    {imageSource}
                </div>
            </div>
        </div>
    );

    const selectReservation = (
        <div className="card" style={{marginTop: "10px"}}>
            <div className="p-grid">
                <div className="p-col-12" style={{width: "100%"}}>
                    {dataTableTemplate(reservations, "UYGUN REZERVASYONLAR", reservationTableData, "reservation", true)}
                </div>
                {beforeStep("Sunucu Bilgileri Giriniz")}
                {afterStep("İmaj Seçiniz")}
            </div>
        </div>
    );

    const keypairInformations = (
        <div className="card" style={{marginTop: "10px"}}>
            <div className="p-grid">
                <div className="p-col-12">
                    <span className="p-field">
                        <label htmlFor="serverName" className="p-d-block">Anahtar Çifti Adı</label>
                        {keypairValidType === "p-success"
                            ?
                            <InputText id="serverName" value={keypairName} className={"p-d-block"}
                                   onChange={(e) => keypairOnChange(e, setKeypairName)}/>
                            :
                            <InputText id="serverName" value={keypairName} className={"p-d-block p-invalid"}
                                   onChange={(e) => keypairOnChange(e, setKeypairName)}/>
                        }

                        <small id="serverName"
                               className={"p-d-block " + keypairValidType}>{keypairValidMessage}</small>
                    </span>
                    <Message severity="info"
                             className="p-mt-5"
                             text="Anahtar Çifti Adı sadece harf, sayı ve alt çizgi (_) içerebilir."/>
                </div>
                {beforeStep("İmaj Seçiniz")}
                {afterStep("Bilgileri Kontrol Ediniz")}
            </div>
        </div>
    );

    const summary = (
        <div className="card" style={{marginTop: "10px"}}>
            <div className="p-grid" align="center">
                {summaryMessageTemplate("Sunucu Adı", serverName, "pi-cloud")}
                {summaryMessageTemplate("Açıklama", serverDescription, "pi-info-circle")}
                {summaryMessageTemplate("Kaynak Adı", selectedSource ? selectedSource.name : null, "pi-folder-open")}
                {summaryMessageTemplate("Kaynak Boyutu", selectedSource ? selectedSource.size : null, "pi-eye")}
                {summaryMessageTemplate("Şablon Adı", selectedReservation ? selectedReservation.flavor_name : null, "pi-file")}
                {summaryMessageTemplate("Ram Boyutu", selectedReservation ? selectedReservation.ram_size : null, "pi-file")}
                {summaryMessageTemplate("Disk Boyutu", selectedReservation ? selectedReservation.disk_size : null, "pi-table")}
                {summaryMessageTemplate("Anahtar Çifti", keypairName, "pi-key")}
                {beforeStep("Anahtar Çifti Ekleyiniz")}
                {finishStep("Sunucu Oluşturuluyor")}
            </div>
        </div>
    );

    return (
        <div className='p-fluid'>
            <Toast ref={toast}/>
            <Spinner loadingState={loadingState}/>
            <div className="steps-demo">
                <div className="card">
                    <Steps model={items} activeIndex={activeIndex} onSelect={(e) => setActiveIndex(e.index)}
                           readOnly={false}/>
                </div>
            </div>

            {activeIndex === 0
                ?
                serverInformations
                :
                null
            }
            {activeIndex === 1
                ?
                selectReservation
                :
                null
            }
            {activeIndex === 2
                ?
                selectSource
                :
                null
            }
            {activeIndex === 3
                ?
                keypairInformations
                :
                null
            }
            {activeIndex === 4
                ?
                summary
                :
                null
            }
        </div>
    );


}

const mapStateToProps = state => {
    return {
        user: state.auth.user,
        management: state.management,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        putMethod: (data, url, type) => {
            return dispatch(management.putMethod(data, url, type));
        },
        postMethod: (data, url, type) => {
            return dispatch(management.postMethod(data, url, type));
        },
        deleteMethod: (data, url, type) => {
            return dispatch(management.deleteMethod(data, url, type));
        },
        logout: () => dispatch(auth.logout()),
        loadUser: () => {
            return dispatch(auth.loadUser());
        },

    }
};

export default connect(mapStateToProps, mapDispatchToProps)(AddServer);


// WEBPACK FOOTER //
// ./src/pages/cloudmanagement/AddServer.jsx